module.exports = __webpack_public_path__ + "img/AboutBG.0dfb336c.jpg";